// Moving blocks in Product page
document.addEventListener("DOMContentLoaded", () => {
 let crossSell = document.querySelector(".shopify-section--main-product .product__info .product-content__cross-sell");
 let shippingFaq = document.querySelector(".shopify-section--main-product .product__info .shipping-and-faq");
 let productMedia = document.querySelector(".shopify-section--main-product .product__media");
 if (window.innerWidth >= 1024) {
  if (crossSell != null) {
   productMedia.appendChild(crossSell);
  } else {
   if (shippingFaq != null) {
    productMedia.appendChild(shippingFaq);
   }
  }
 }
});
// end: Moving blocks in Product page

// Zoom image on Product page
function _loadScript(_src) {
 let head = document.getElementsByTagName('head')[0];
 let s = document.createElement('script');
 s.type = 'text/javascript';
 s.src = _src;
 head.appendChild(a);
}

function zoom(e) {
 var zoomer = e.currentTarget;
 e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
 e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
 x = offsetX / zoomer.offsetWidth * 100
 y = offsetY / zoomer.offsetHeight * 100
 zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

document.addEventListener("DOMContentLoaded", () => {
 if (window.innerWidth >= 1024) {
  if (document.querySelector(".shopify-section--main-product") != null) {
   setTimeout(function () {

    let elms = document.getElementsByClassName("product__media-item");
    for (var i = 0; i < elms.length; i++) {
     divSel = elms[i];
     divSelTag = divSel.getElementsByClassName('product__media-image-wrapper')[0];
     let imgTag = divSelTag.querySelector('img');
     _img = imgTag.getAttribute('src');
     if (_img != null) {
      divSelTag.style.backgroundImage = "url(" + _img + ")";
      divSelTag.setAttribute('onmousemove', "zoom(event)");
      divSelTag.classList.add("is-zoom");
     }
    }
   }, 400);
  }
 }
});
// end: Zoom image on Product page

// Adding an additional item to the cart
document.addEventListener("DOMContentLoaded", () => {
  const btn_add_to_cart = document.querySelectorAll(".product_btn_add_to_cart");
  const products_in_cart = [];
    
  jQuery.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
  }).then((data) => {
    data.items.forEach(function(item, i) {
      products_in_cart.push(item.id);
    });
    if (products_in_cart.length != 0) {
      btn_add_to_cart.forEach(function(item, i) {
        for (var x = 0; x < products_in_cart.length; x++) {
          if (Number(btn_add_to_cart[i].getAttribute("data_cross_sell_product_id")) == products_in_cart[x]) {
            if(btn_add_to_cart[i].classList.contains('product_btn_add_to_cart--small')) {
              btn_add_to_cart[i].innerHTML = "Remove";
            } else {
              btn_add_to_cart[i].innerHTML = "Remove from cart";
            }
            btn_add_to_cart[i].setAttribute("data_product_status", "Remove from cart");
          }
        }
      });
    }
  });

  function updateCartTotal(){
       jQuery.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
  }).then((data) => {
         var total = data.item_count;
         if (total <= 0) total = 0;
     $('cart-count').text(total);         
  });
  }
  
  btn_add_to_cart.forEach(function(item) {
    item.addEventListener("click", function(e) {
      if (item.getAttribute("data_product_status") == "Add to cart") {
        item.setAttribute("disabled", "disabled");
        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: {
              id: item.getAttribute("data_cross_sell_product_id"),
              quantity: 1,
            },
          }).then((data) => {
            item.setAttribute("disabled", "");
            updateCartTotal();
           
            if(item.classList.contains('product_btn_add_to_cart--small')) {
              item.innerHTML = "Remove";
            } else {
              item.innerHTML = "Remove from cart";
            }
            item.setAttribute("data_product_status", "Remove from cart");
          });
      } else if (item.getAttribute("data_product_status") == "Remove from cart") {
        item.setAttribute("disabled", "disabled");
        jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
              id: item.getAttribute("data_cross_sell_product_id"),
              quantity: 0,
            },
        }).then((data) => {
            item.setAttribute("disabled", "");
            updateCartTotal();
            item.innerHTML = "Add to cart";
            item.setAttribute("data_product_status", "Add to cart");
        });
      }
    });
  });
});
// end: Adding an additional item to the cart

document.addEventListener("DOMContentLoaded", () => {
  const btn_show_contact = document.querySelector(".fixed-contacts");
  btn_show_contact.addEventListener("click", function(e) {
    btn_show_contact.classList.toggle("opened5");
  });
  const faq_btn_show_content = document.querySelectorAll(".faq-block__content-item-line");
  faq_btn_show_content.forEach(item => {
    item.addEventListener("click", function(e) {
      var faq_btn_show_content_block = item.parentNode;
      item.querySelector(".faq-block__content-handler").classList.toggle("opened3");
      faq_btn_show_content_block.querySelector(".faq-block__content-item-detail").classList.toggle("hidden");
    });
  });

  const cart_price_discount_block = document.querySelectorAll(".cart_price_discount_block");

  cart_price_discount_block.forEach(function(item) {
    var price_count = item.querySelectorAll(".cart_price_discount_price > span");
    if (price_count.length == 2) {
      var block_procent = item.querySelector(".cart_price_discount_procent");
      var new_price = item.querySelector(".cart_price_discount_price > .price--highlight").innerText.split("$").pop().replace(/[\s.,%]/g, '');
      var old_price = item.querySelector(".cart_price_discount_price > .price--compare").innerText.split("$").pop().replace(/[\s.,%]/g, '');
      var procent = Math.round((Number(old_price) - Number(new_price)) / (Number(old_price) / 100));
      var discount_text = document.createElement("b");
      discount_text.innerHTML = procent + '%';
      block_procent.appendChild(discount_text)
    }
  });
});
